import type { FaireProductEntity } from "../../entity_types/product";

export const p_262xug4ytk: FaireProductEntity = {
  token: "p_262xug4ytk",
  type: "product",
  name: "Yellow Flowers Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c84e498d66a7a2eeff3187401d5a86e501ddb5a7320aec9f742265bff1138132.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12eba6420b8b916c10e39c5d7df1beba587806daef3e898446f7f2a62e368fca.png",
    "https://cdn.faire.com/fastly/48470264bccb07ebca37dd54d43507ea44873a6372b90f86186a86978f3c1181.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:55.056Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
